export default __webpack_public_path__ + "static/media/pxec03-dm.bf53b130.png";